import {
    HTTP
} from '@/utilities/http-common';

export default {
    namespaced: true,
    state: {
        adverse_count: 0,
        serious_adverse_count: 0,
        other_serious_adverse_count: 0,
        ten_day_aesae_count: 0
    },
    getters: {},
    mutations: {
        setAdverseCount(state, count) {
            state.adverse_count = count;
        },
        getAdverseCount(state) {
            return state.adverse_count;
        },
        setSeriousAdverseCount(state, count) {
            state.serious_adverse_count = count.user_required;
            state.other_serious_adverse_count = count.other_required;
        },
        getSeriousAdverseCount(state) {
            return state.serious_adverse_count;
        },
        setTenDayAESAECount(state, count) {
            state.ten_day_aesae_count = count;
        },
        getTenDayAESAECount(state) {
            return state.ten_day_aesae_count;
        }
    },
    actions: {
        setAdverseEventsCount({
            commit
        }, count) {
            commit('setAdverseCount', count);
        },
        getAdverseEventsCount() {
            return HTTP.get('/kenya/adverse_events/get_count');
        },
        setSeriousAdverseEventsCount({
            commit
        }, count) {
            commit('setSeriousAdverseCount', count);
        },
        getSeriousAdverseEventsCount() {
            return HTTP.get('/kenya/serious_adverse_events/get_count');
        },
        setTenDayAESAECount({
            commit
        }, count) {
            commit('setTenDayAESAECount', count);
        },
        getTenDayAESAECount() {
            return HTTP.get('/kenya/ten-day-open-aesae-count/');
        }
    },
}